import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'

const AddCostModel = ({ modal, toggle, HandWorkListApi, editData, handWorkId, uniqueNo, standardHours }) => {
    const { postApi, putApi, getApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [otherCostData, setOtherCostData] = useState([])
    const [totalOtherCost, setTotalOthercost] = useState(0)
    useEffect(() => {
        if (handWorkId > 0) {
            getApi(`OtherCost/data/list?handworkCostId=${parseInt(handWorkId)}`).then(({ data, status }) => {
                if (status === 200) {
                    if (data.length > 0) {
                        let options = data.map((item) => ({
                            Id: item.Id,
                            label: item.Name,
                            Cost: parseFloat(item.Cost),
                            CalculatedCost: item.CalculatedCost,
                            TotalHours: item.TotalHours,
                        }));
                        setOtherCostData(options)
                    } else {
                        getApi('OtherCost/lookup').then(({ data, status }) => {
                            if (status === 200) {
                                let options = data.map((item) => ({
                                    Id: item.Key,
                                    label: item.Value,
                                    Cost: parseFloat(item.Value2) * parseFloat(standardHours)
                                }));
                                setOtherCostData(options)
                            } else {
                                toast.error(data, {
                                    style: { fontSize: "15px" },
                                })
                            }
                        })
                    }
                } else {
                    toast.error(data, {
                        style: { fontSize: "15px" },
                    })
                }
            })
        }
    }, [modal])

    useEffect(() => {
        const total = otherCostData.reduce(
            (sum, item) => sum + (parseFloat(item.CalculatedCost) || 0),
            0
        );
        setTotalOthercost(total);
    }, [otherCostData]);

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleOtherCostChange = (index, value) => {
        const updated = [...otherCostData];
        updated[index].CalculatedCost = value === "" ? "" : parseFloat(value);
        setOtherCostData(updated);
    };

    //  Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            MaterialCost: editData ? (editData?.MaterialCost || 0) : '',
        },
        validationSchema: Yup.object({
            MaterialCost: Yup.string().required("The material cost is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            const payload = {
                OtherCosts: otherCostData
                    .map(item => ({
                        Id: item?.Id || 0,
                        OtherCostId: item.Id,
                        Cost: parseFloat(item.CalculatedCost),
                    })),
                HandWorkId: handWorkId,
                MaterialCost: parseFloat(values.MaterialCost),
                WorkerCost: parseFloat(values.WorkerCost),
                OtherCost: parseFloat(totalOtherCost),
            };
            const apiCall = postApi
            const apiEndpoint = "HandWorkCosting/add/cost"
            apiCall(apiEndpoint, payload).then(({ data, status }) => {
                setformSumitLoading(false)
                if (status === 200) {
                    validation.handleReset()
                    toast.success("Successfully Added", {
                        style: { fontSize: "15px" },
                    })
                    toggle()
                    if (HandWorkListApi != '') {
                        HandWorkListApi()
                    }
                }
                else {
                    toast.error(data, {
                        style: { fontSize: "15px" },
                    })
                }
            })

        },
    })

    // cancle handler
    const handleCancle = () => {
        toggle()
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="defualt"
            style={{ width: !isMobile ? "500px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {"Add Cost"} (Unique No.: {uniqueNo})
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >

                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Material Cost
                                    </Label>
                                    <Input
                                        name="MaterialCost"
                                        placeholder="0"
                                        type="text"
                                        rows={4}
                                        className="form-control-sm"
                                        onKeyPress={handleKeyPress}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.MaterialCost}
                                        invalid={
                                            validation.touched.MaterialCost && validation.errors.MaterialCost
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.MaterialCost && validation.errors.MaterialCost ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.MaterialCost}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col md={6}>
                                <Label style={{ fontWeight: "500", fontSize: "14px" }}>
                                    Other Cost:{" "}
                                    <span style={{ color: "blue", fontWeight: "600" }}>
                                        <i className="mdi mdi-currency-inr"></i>
                                        {new Intl.NumberFormat("en-IN", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }).format(totalOtherCost || 0)}
                                    </span>
                                </Label>
                            </Col>
                            <Col md={6} className='text-end'>
                                <Label style={{ fontWeight: "500", fontSize: "14px" }}>
                                    Total Hours:{" "}
                                    <span style={{ color: "blue", fontWeight: "600", marginLeft: "2px" }}>
                                        {(otherCostData[0]?.TotalHours || 0)}
                                    </span>
                                </Label>
                            </Col>
                        </Row>

                        <Row>
                            {otherCostData.map((item, index) => (
                                <Col key={item.Id} md={6}>
                                    <FormGroup className="mb-2">
                                        <Label style={{ display: "flex", justifyContent: "space-between" }}>
                                            <span>{item.label}</span>  <span style={{ fontWeight: "600" }}>Cost:  <i className="mdi mdi-currency-inr"></i>
                                                {new Intl.NumberFormat("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }).format(item.Cost || 0)}</span></Label>
                                        <Input
                                            type="text"
                                            placeholder='0'
                                            className="form-control-sm"
                                            value={item.CalculatedCost}
                                            onChange={(e) => handleOtherCostChange(index, e.target.value)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </FormGroup>
                                </Col>
                            ))}
                        </Row>

                        <div className="text-end">
                            <Button
                                user="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                onClick={handleCancle}
                            >
                                Cancle
                            </Button>

                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    color="secondary"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    user="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default AddCostModel